import React from 'react';
import { Main } from './components';

const Home = () => <Main />;

export default Home;
